import { ECasinoGameMode, ECasinoGameViewOrder } from 'interfaces/casino-data';

export const normalizeStringifiedQuery = (stringifiedQuery: string) => {
  const splittedQuery = stringifiedQuery.slice(1).split('&');
  const firstGameIndex = splittedQuery.findIndex(
    query =>
      query.startsWith(`${ECasinoGameViewOrder.FIRST}-`) &&
      (query.endsWith(`${ECasinoGameMode.FUN}`) ||
        query.endsWith(`${ECasinoGameMode.REAL}`))
  );

  const secondGameIndex = splittedQuery.findIndex(
    query =>
      query.startsWith(`${ECasinoGameViewOrder.SECOND}-`) &&
      (query.endsWith(`${ECasinoGameMode.FUN}`) ||
        query.endsWith(`${ECasinoGameMode.REAL}`))
  );

  if (firstGameIndex < 0 && secondGameIndex < 0) {
    return stringifiedQuery;
  }

  if (firstGameIndex > secondGameIndex) {
    const temp = splittedQuery[firstGameIndex];
    splittedQuery[firstGameIndex] = splittedQuery[secondGameIndex];
    splittedQuery[secondGameIndex] = temp;
  }

  return `?${splittedQuery.join('&')}`;
};
